import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  confirmDelete(event) {
    this.pendingDeleteUrl = event.currentTarget.dataset.url;
  }

  async deleteComment() {
    if (!this.pendingDeleteUrl) return;

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");

    const response = await fetch(this.pendingDeleteUrl, {
      method: "DELETE",
      headers: { "X-CSRF-Token": csrfToken, Accept: "text/vnd.turbo-stream.html" },
    });

    if (response.ok) {
      Turbo.renderStreamMessage(await response.text());
    }

    this.pendingDeleteUrl = null;
  }
}
